// export const SET_GRUPOS = 'SET_GRUPOS';
// export const SET_LOADING = 'SET_LOADING';
// export const SET_EMPTY = 'SET_EMPTY';
// export const SET_DYNAMIC_MODAL = 'SET_DYNAMIC_MODAL';
// export const REMOVE_GROUP = 'REMOVE_GROUP'; // Asegúrate de importar este tipo
// export const SET_SAVING = 'SET_SAVING';
// export const UPDATE_ACTIVITY_POSITIONS = 'UPDATE_ACTIVITY_POSITIONS';

// const initialState = {
//     grupos: [],
//     isLoading: true,
//     isSaving: false,
//     isEmpty: false,
//     dynamicModalObj: { isOpen: false, pos: { x: '', y: '' }, type: '' }
// }

// export function grupoReducer(state = initialState, action) {
//     var newState = state

//     switch (action.type) {
//         case SET_GRUPOS:
//             newState = { ...newState, grupos: action.grupos }
//         case SET_LOADING:
//             newState = { ...newState, isLoading: action.isLoading }
//         case SET_EMPTY:
//             newState = { ...newState, isEmpty: action.isEmpty }
//         case SET_DYNAMIC_MODAL:{
//                 return {...newState, dynamicModalObj: action.dynamicModalObj}
//             }
//         case SET_SAVING:
//                 return { ...state, isSaving: action.isSaving }
//         case REMOVE_GROUP:
//              newState = {...newState, grupos: newState.grupos.filter(grupo => grupo.id_grupo !== action.idGrupo)};
//         case UPDATE_ACTIVITY_POSITIONS:
//             return { 
//                 ...state, 
//                 grupos: action.grupos 
//             };

//     }
    
//     return newState;
// }


//VERSION DE PRUEBA ESTABLE:

// grupo.reducer.js
export const SET_GRUPOS = 'SET_GRUPOS';
export const SET_LOADING = 'SET_LOADING';
export const SET_EMPTY = 'SET_EMPTY';
export const SET_DYNAMIC_MODAL = 'SET_DYNAMIC_MODAL';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const SET_SAVING = 'SET_SAVING';
export const UPDATE_ACTIVITY_POSITIONS = 'UPDATE_ACTIVITY_POSITIONS';

const initialState = {
    grupos: [],
    isLoading: true,
    isSaving: false,
    isEmpty: false,
    dynamicModalObj: { isOpen: false, pos: { x: '', y: '' }, type: '' }
}

export function grupoReducer(state = initialState, action) {
    var newState = state

    switch (action.type) {
        case SET_GRUPOS:
            return { ...state, grupos: action.grupos };
        case SET_LOADING:
            return { ...state, isLoading: action.isLoading };
        case SET_EMPTY:
            newState = { ...state, isEmpty: action.isEmpty }
        case SET_DYNAMIC_MODAL:
            return { ...state, dynamicModalObj: action.dynamicModalObj };
        case SET_SAVING:
            return { ...state, isSaving: action.isSaving };
        case REMOVE_GROUP:
            return { 
                ...state, 
                grupos: state.grupos.filter(grupo => grupo.id_grupo !== action.idGrupo) 
            };
        case UPDATE_ACTIVITY_POSITIONS:
            return { 
                ...state, 
                grupos: action.grupos 
            };
        default:
            return state;
    }
}


